import { render, staticRenderFns } from "./UpdateOrderProcessSwitches.vue?vue&type=template&id=1fb6a5ad&scoped=true"
import script from "./UpdateOrderProcessSwitches.vue?vue&type=script&lang=js"
export * from "./UpdateOrderProcessSwitches.vue?vue&type=script&lang=js"
import style0 from "./UpdateOrderProcessSwitches.vue?vue&type=style&index=0&id=1fb6a5ad&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fb6a5ad",
  null
  
)

export default component.exports